import moment from "moment";
import { Label } from "semantic-ui-react";

const getGenderPrefix = (patient, parameters) => {
	if (!patient || !parameters || !patient.gender) return "";

	const birth = patient.birth_date ?? patient.birthdate;
	const age = moment().diff(birth, "years");

	const rules = {
		m: {
			baby: parameters.ageBabyBoyPrefix,
			child: parameters.ageChildBoyPrefix,
			adult: parameters.ageManPrefix,
		},
		f: {
			baby: parameters.ageBabyGirlPrefix,
			child: parameters.ageChildGirlPrefix,
			adult: parameters.ageWomanPrefix,
		},
		o: {
			baby: parameters.ageBabyOtherPrefix,
			child: parameters.ageChildOtherPrefix,
			adult: parameters.ageOtherPrefix,
		},
	};

	const prefixSet = rules[patient.gender];
	if (!prefixSet) return "";

	if (age < parameters.ageMaxBaby) return prefixSet.baby;
	if (age < parameters.ageMaxChild) return prefixSet.child;
	return prefixSet.adult;
};

export const displayGender = (patient, parameters) => {
	const prefix = getGenderPrefix(patient, parameters);
	if (!prefix) return null;

	return (
		<Label color={patient?.gender === "m" ? "blue" : "pink"} size="small">
			<span>{prefix}</span>
		</Label>
	);
};

export const displayGenderText = (patient, parameters) => {
	const prefix = getGenderPrefix(patient, parameters);
	return prefix ? `(${prefix}) ` : "";
};
